import React, { FC, useMemo } from 'react';
import { Platform, Image as RNImage, TouchableOpacity } from 'react-native';
import { get, isEmpty, isUndefined } from 'lodash';
import { useSelector } from 'react-redux';

import { AppVersion } from 'click-types';
import { appInfoSelector } from '@common/redux/selectors/app';
import { defaultURL } from '@common/constants/shared';
import { IImage } from '@common/types/element';
import { getValueBindingComponent } from '@common/utils/component';
import {
  getActions,
  getItemListClick,
} from '@common/utils/handleActions/func/helps';
import createStyles from './style';
import { ImageSecurity } from '@common/components/ImageSecurity';

const CusImage: FC<IImage> = (attrs) => {
  const appInfo = useSelector(appInfoSelector);
  const urlBinding = useMemo(() => {
    const { imageType } = attrs;

    switch (imageType) {
      case 'uploaded':
        return attrs?.filename1x;

      case 'url':
        return getValueBindingComponent(attrs, 'imageURL');

      default:
        return getValueBindingComponent(attrs, 'url');
    }
  }, [attrs]);

  const hasPlaceholder = get(attrs, 'imageUrl.binding.options', {});
  const isUrl =
    !urlBinding && hasPlaceholder.placeholderImageEnabled
      ? hasPlaceholder?.placeholderImage
      : isEmpty(hasPlaceholder) && !urlBinding
      ? ''
      : urlBinding;

  const url = isUndefined(isUrl) ? defaultURL : isUrl;

  const styles = createStyles(attrs, Platform, isEmpty(isUrl));

  const handlePress = (event: any) => {
    event.preventDefault();
    let arrayAction = getActions(attrs.actions);

    attrs.onPress &&
      attrs.onPress(arrayAction, {
        itemListClick: getItemListClick(attrs?.record),
      });
  };
  const defaultSource = hasPlaceholder?.placeholderImageEnabled
    ? hasPlaceholder?.placeholderImage
      ? hasPlaceholder?.placeholderImage
      : defaultURL
    : '';

  return (
    <TouchableOpacity
      disabled={isEmpty(attrs.actions)}
      activeOpacity={1}
      style={styles.container}
      {...(attrs.actions && {
        onPress: handlePress,
      })}
    >
      {isEmpty(isUrl) &&
      !hasPlaceholder?.placeholderImageEnabled ? null : Platform.OS !==
        'web' ? (
        <ImageSecurity src={url}>
          {({ imageUrl }) => (
            <RNImage
              style={[styles.img]}
              resizeMode={attrs?.imageResize}
              resizeMethod={'resize'}
              source={{ uri: imageUrl }}
              defaultSource={defaultSource}
            />
          )}
        </ImageSecurity>
      ) : (
        <ImageSecurity src={url}>
          {({ imageUrl }) => (
            <img
              src={imageUrl}
              style={{
                borderRadius:
                  appInfo?.version === AppVersion.V4
                    ? attrs?.style?.borderRadius
                    : attrs.borderRadius,
                objectFit: attrs?.imageResize,
                width: '100%',
                height: '100%',
              }}
            />
          )}
        </ImageSecurity>
      )}
    </TouchableOpacity>
  );
};

export default React.memo(CusImage);
